import { Alert, Button, Group, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconAlertTriangle, IconCopy, IconRefresh } from '@tabler/icons-react';

export interface NoteAutosaveRecoveryBannerProps {
  onRetry: () => void;
  onCopyNote: () => Promise<void>;
  retrying?: boolean;
}

export function NoteAutosaveRecoveryBanner({
  onRetry,
  onCopyNote,
  retrying = false,
}: NoteAutosaveRecoveryBannerProps): JSX.Element {
  const handleCopy = async () => {
    try {
      await onCopyNote();
      notifications.show({
        color: 'green',
        title: 'Note copied',
        message: 'Note text is on your clipboard.',
      });
    } catch {
      notifications.show({
        color: 'red',
        title: 'Could not copy note',
        message: 'Select and copy your note manually before closing this tab.',
      });
    }
  };

  return (
    <Alert
      icon={<IconAlertTriangle size={16} />}
      color="red"
      variant="light"
      radius="md"
      title="Autosave failed. Your edits are still on this page."
      styles={{ root: { borderRadius: 0, borderBottom: '1px solid var(--mantine-color-red-2)' } }}
    >
      <Group gap="sm" mt="xs" wrap="wrap">
        <Button
          size="xs"
          variant="light"
          color="red"
          leftSection={<IconRefresh size={14} />}
          loading={retrying}
          onClick={onRetry}
        >
          Retry now
        </Button>
        <Button
          size="xs"
          variant="subtle"
          color="red"
          leftSection={<IconCopy size={14} />}
          onClick={() => void handleCopy()}
        >
          Copy note text
        </Button>
      </Group>
      <Text size="xs" c="red.8" mt="xs" fw={600}>
        Do not close this tab until saved.
      </Text>
    </Alert>
  );
}
